// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1nPVy","cell":"ColumnAccessor_cell__eOVIp","firstCellAccent":"ColumnAccessor_firstCellAccent__1yfBS"};